module.exports = __webpack_public_path__ + "img/debi_parkhaus_ocular-2.21b947ac.jpg";